import React, { Component } from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

import { StyledWrapperTimes, StyledTimePicker } from './style';

class InputTime extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: null
    };
  }

  handleDateChange = selectedDate => {
    const { onChange } = this.props;
    onChange(`${moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss')}Z`);
    this.setState({
      selectedDate
    });
  };

  render() {
    const { selectedDate } = this.state;
    const { className, value } = this.props;

    return (
      <StyledWrapperTimes className={className}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <StyledTimePicker
            ampm={false}
            openTo="hours"
            views={['hours', 'minutes', 'seconds']}
            format="HH:mm:ss"
            value={!selectedDate || value === null ? value : selectedDate}
            onChange={this.handleDateChange}
            okLabel="Aceptar"
            cancelLabel="Cancelar"
            todayLabel="Hoy"
          />
        </MuiPickersUtilsProvider>
      </StyledWrapperTimes>
    );
  }
}

export default InputTime;
